import React from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencySymbol } from './CurrencySymbol';
import { manatIconStyles } from './styled';
import { getDisplayPrice } from './heplers';
import { DisplayPriceParams } from './types';
import { prettyNumber } from '../../../utils/helpers';

type PriceDisplayProps = DisplayPriceParams;

export const PriceDisplay: React.FC<PriceDisplayProps> = props => {
  const { t } = useTranslation();
  const { value, currency, cy, priceUnit, rentSuffix } = getDisplayPrice(props);

  return (
    <>
      <span data-cy={cy}>{prettyNumber(value)}</span>
      <CurrencySymbol currency={currency} iconStyles={manatIconStyles} />
      {priceUnit && <span data-cy={priceUnit.cy}>{priceUnit.text}</span>}
      {rentSuffix && (
        <span data-cy={rentSuffix.cy}>
          /{t(`cards.item_card.${rentSuffix.type}`)}
        </span>
      )}
    </>
  );
};
